import {
  GET_ACCSETTING,
  GET_ACCSETTING_SUCCESS,
  GET_ACCSETTING_FAIL,
  DELETE_ACCSETTING,
  DELETE_ACCSETTING_SUCCESS,
  DELETE_ACCSETTING_FAIL,
  UPDATE_ACCSETTING,
  UPDATE_ACCSETTING_SUCCESS,
  UPDATE_ACCSETTING_FAIL,
  ADD_NEW_ACCSETTING,
  ADD_ACCSETTING_SUCCESS,
  ADD_ACCSETTING_FAIL,
  ACCSETTING_LOADING,
  ACCSETTING_RESET,
} from "./actionType";

export const resetAccSettingState = (actionType) => ({
  type: ACCSETTING_RESET,
  payload: { actionType },
});

export const getAccSettingSuccess = (actionType, data) => ({
  type: GET_ACCSETTING_SUCCESS,
  payload: { actionType, data },
});

export const getAccSettingFail = (actionType, error) => ({
  type: GET_ACCSETTING_FAIL,
  payload: { actionType, error },
});

export const getAccSetting = data => ({
  type: GET_ACCSETTING,
  payload: data,
});

export const getAccSettingLoading = () => ({
  type: ACCSETTING_LOADING
});

export const deleteAccSetting = data => ({
  type: DELETE_ACCSETTING,
  payload: data,
});

export const deleteAccSettingSuccess = data => ({
  type: DELETE_ACCSETTING_SUCCESS,
  payload: data,
});

export const deleteAccSettingFail = error => ({
  type: DELETE_ACCSETTING_FAIL,
  payload: error,
});

export const updateAccSetting = data => ({
  type: UPDATE_ACCSETTING,
  payload: data,
});

export const updateAccSettingFail = error => ({
  type: UPDATE_ACCSETTING_FAIL,
  payload: error,
});

export const updateAccSettingSuccess = data => ({
  type: UPDATE_ACCSETTING_SUCCESS,
  payload: data,
});

export const addNewAccSetting = data => ({
  type: ADD_NEW_ACCSETTING,
  payload: data,
});

export const addAccSettingSuccess = data => ({
  type: ADD_ACCSETTING_SUCCESS,
  payload: data,
});

export const addAccSettingFail = error => ({
  type: ADD_ACCSETTING_FAIL,
  payload: error,
});